import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Table from '@zg-rentals/multibrand-ui/lib/Table';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// Stylesheets
import './style.scss';

const propTypes = {
    headerList: PropTypes.array.isRequired,
    rowList: PropTypes.array.isRequired,
    emptyMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    alignRight: PropTypes.bool,
    isEstimate: PropTypes.bool,
};

const defaultProps = {
    errorMessage: '',
    isLoading: false,
    alignRight: true,
    isEstimate: false,
};

function getColumnStyle(index, alignRight) {
    if (index === 0) {
        return 'AnalyticsTable-property';
    }
    if (alignRight) {
        return 'AnalyticsTable-align-right';
    }
    return '';
}

function Error({ message }) {
    return (
        <Container>
            <Row>
                <Col>
                    <Text className="error">
                        {message}
                    </Text>
                </Col>
            </Row>
        </Container>
    );
}

function Header({ header = [], alignRight }) {
    return (
        <Table.Row className="AnalyticsTable-row">
            {header.map((headerItem, index) => (
                <Table.Col isHeader={true} key={index} className={getColumnStyle(index, alignRight)}>
                    {headerItem}
                </Table.Col>
            ))}
        </Table.Row>
    );
}

function AnalyticsRow({ row = {}, alignRight }) {
    return (
        <Table.Row className="AnalyticsTable-row">
            {Object.keys(row).map((key, index) => (
                <Table.Col key={key} className={getColumnStyle(index, alignRight)}>
                    {row[key]}
                </Table.Col>
            ))}
        </Table.Row>
    );
}

const AnalyticsTable = ({
    headerList,
    rowList,
    errorMessage,
    emptyMessage,
    isLoading,
    alignRight,
    isEstimate,
}) => {
    if (isLoading) {
        return <SpinnerContainer />;
    }

    if (errorMessage) {
        return <Error message={errorMessage} />;
    }

    return (
        <div>
            <Table>
                <Header header={headerList} alignRight={alignRight} />
                {rowList.map((row, index) => <AnalyticsRow key={index} row={row} alignRight={alignRight} />)}
            </Table>
            {(rowList && rowList.length === 0) &&
                <Error message={emptyMessage} />
            }
            {isEstimate && (
                <Text className="AnalyticsTable-estimate" type="body-tiny" lowlight={true}>
                    These numbers are an estimate. Finalized numbers will appear on your invoice.
                </Text>
            )}
        </div>
    );
};

AnalyticsTable.propTypes = propTypes;
AnalyticsTable.defaultProps = defaultProps;

export default AnalyticsTable;
